import PropTypes from 'prop-types';
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

//Import Icons
import FeatherIcon from "feather-icons-react";

// Reactstrap
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row, Tooltip } from "reactstrap";

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

// import images
import logoSvg from "../../assets/images/logo.png";

//i18n
import { withTranslation } from "react-i18next";
//redux
import { useDispatch, useSelector } from "react-redux";

// Redux Store
import { airCargoTracking, containerTracking, growth, timeTracking } from '../../assets/images';
import { hasAirCargoTracking, hasContainerTracking, hasMarketingPermission, hasSailingSchedule } from '../../common/data/ApplicationModules';
import {
  changeSidebarType,
  changelayoutMode,
  showRightSidebarAction,
  toggleLeftmenu
} from "../../store/actions";
import UserGroupIconCard from '../GlobalComponent/UserGroupIconCard';

const Header = props => {
  const dispatch = useDispatch();
  const { showRightSidebar } = useSelector((state) => ({
    showRightSidebar: state.Layout.ShowRightSidebar
  }));
  const { tenant_info } = useSelector((state) => state?.settings);
  const { onChangeLayoutMode } = props;
  const [search, setsearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [isClick, setClick] = useState(false);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    var body = document.body;
    setClick(!isClick);
    if (isClick === true) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'sm');
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'lg');
    }
  }
  const isLogoValid = tenant_info?.logo && tenant_info.logo.length > `${process.env.REACT_APP_API_BASE_URL}/api/v1/misc/download-file/`.length;
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={isLogoValid ? tenant_info.logo : logoSvg} alt="Logo" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={isLogoValid ? tenant_info.logo : logoSvg} alt="Logo" height="50" />
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={isLogoValid ? tenant_info.logo : logoSvg} alt="Logo" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={isLogoValid ? tenant_info.logo : logoSvg} alt="Logo" height="50" width="64" />
                </span>
              </Link>
            </div>

            <button
              onClick={() => {
                tToggle();
              }}
              type="button" className="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn">
              <i className="fa fa-fw fa-bars"></i>
            </button>

            {/* <LanguageDropdown /> */}

          </div>

          {/* <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button type="button" className="btn header-item" id="page-header-search-dropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FeatherIcon
                  icon="search"
                  className="icon-lg"
                />
              </button>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown">

                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input type="text" className="form-control" placeholder="Search ..." aria-label="Search Result" />

                      <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> */}
          <div className="d-flex align-items-center">
            {/* <div className="dropdown d-inline-block d-lg-none mobile_search">
              <button onClick={() => { setsearch(!search); }} type="button" className="btn header-item noti-icon common_header_btn" id="page-header-search-dropdown" >
                <FeatherIcon icon="search" className="icon-lg" />
              </button>
              <div
                className={search ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show" : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"}
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn" type="submit">
                          <FeatherIcon
                            icon="search"
                            className="icon-lg"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input type="search" className="form-control" placeholder="Search" />
                <button className="btn" type="button">
                  <FeatherIcon
                    icon="search"
                    className="icon-lg"
                  />
                  <i className="bx bx-search-alt align-middle"></i>
                </button>
              </div>
            </form> */}

            {/* light / dark mode */}
            {/* <LightDark layoutMode={props['layoutMode']} onChangeLayoutMode={onChangeLayoutMode} /> */}

            <Dropdown className="d-none d-lg-inline-block ms-1" style={{ marginTop: '0px' }}
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}>
              <DropdownToggle
                className="btn header-item noti-icon "
                tag="button">
                <FeatherIcon
                  icon="grid"
                  className="icon-lg"
                />
              </DropdownToggle>
              {/* Add text below the icon */}
              <div style={{ textAlign: "center", fontSize: "12px", color: "#6c757d", position: 'fixed', marginTop: '-30px', marginLeft: '9px' }}>
                Apps
              </div>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end" style={{ backgroundColor: "white", boxShadow: "3px 3px #d1d5db61", border: "1px solid rgb(134 138 145 / 38%)" }}>
                <div className="p-2">
                  <Row className="g-0">
                    {hasMarketingPermission() && (
                      <React.Fragment>
                        <Col>
                          <Link className="dropdown-icon-item" to="/lead-genaration-page">
                            <UserGroupIconCard icon={growth} alt="Marketing" text="Marketing" />
                          </Link>
                        </Col>
                      </React.Fragment>
                    )}
                    {hasContainerTracking() && (
                      <React.Fragment>
                        <Col>
                          <Link className="dropdown-icon-item" to="/container-tracking">
                            <UserGroupIconCard icon={containerTracking} alt="containerTracking" text="Container Tracking" />
                          </Link>
                        </Col>
                      </React.Fragment>
                    )}
                    {hasSailingSchedule() && (
                      <React.Fragment>
                        <Col>
                          <Link className="dropdown-icon-item" to="/sailing-schedule">
                            <UserGroupIconCard icon={timeTracking} alt="dribbble" text="Shipping Schedule" />
                          </Link>
                        </Col>
                      </React.Fragment>
                    )}
                    {hasAirCargoTracking() && (
                      <React.Fragment>
                        <Col className="position-relative">
                          <Link
                            id="air-tracking-disabled"          // tooltip target
                            to="#"
                            onClick={(e) => e.preventDefault()}  // block navigation
                            className="dropdown-icon-item disabled-link"
                          >
                            <UserGroupIconCard
                              icon={airCargoTracking}
                              alt="dropbox"
                              text="Air Cargo Tracking"
                            />
                            {/* Optional banner overlay */}
                            <div className="coming-soon-banner">Coming&nbsp;Soon</div>
                          </Link>

                          {/* reactstrap tooltip */}
                          <Tooltip
                            placement="top"
                            isOpen={tooltipOpen}
                            target="air-tracking-disabled"
                            toggle={toggleTooltip}
                          >
                            Coming Soon
                          </Tooltip>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  {/* <Row className="g-0">
                  
                  </Row> */}
                </div>
              </DropdownMenu>
            </Dropdown>
            {/* <button className='btn common_header_btn'>
              <img src={message_Icon} alt="Message" />
            </button> */}
            {/* <NotificationDropdown /> */}

            {/* <div onClick={() => { dispatch(showRightSidebarAction(!showRightSidebar)); }} className="dropdown d-md-inline-block d-none" >*/}
            {/*  <button type="button" className="btn header-item noti-icon right-bar-toggle" >*/}
            {/*    <FeatherIcon icon="settings" className="icon-lg" />*/}
            {/*  </button>*/}
            {/*</div>*/}

            <ProfileMenu />

          </div>
        </div>
      </header>

    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  changelayoutMode: PropTypes.func,
  layoutMode: PropTypes.any,
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    layoutMode
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, layoutMode };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  changelayoutMode,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
